module.exports = __webpack_public_path__ + "static/media/机组2222_03.fc50c98f.png";